module.exports = __webpack_public_path__ + "img/bd-javazon.95cc7793.png";